'use client';

import { useCallback, useMemo } from 'react';
import classnames from 'classnames';

import { useCookies } from '@personly/libs-providers';

import { useConsents } from '../../providers/consents';

const className = classnames(
  'border',
  'border-jumbotron-border-color',
  'py-1.5',
  'px-2',
  'rounded',
  'bg-jumbotron-background-color',
  'text-header-title-color',
  'focus:outline-none',
  'active:outline-none',
  'hover:outline-none',
  'disabled:!opacity-60',
  'disabled:!border'
);

interface Props {
  acceptAll: string;
  acceptSelected: string;
  cookieTypes: any;
}

const ConsentAcceptSelectedButton = ({
  acceptAll,
  acceptSelected,
  cookieTypes,
}: Props) => {
  const { selectedCookieTypes } = useConsents();
  const { setConsent } = useCookies();

  const allSelected = useMemo(() => {
    for (const cookieType of cookieTypes) {
      if (!selectedCookieTypes.includes(cookieType.handle)) return false;
    }

    return true;
  }, [cookieTypes, selectedCookieTypes]);

  const text = useMemo(
    () => (allSelected ? acceptAll : acceptSelected),
    [allSelected, acceptAll, acceptSelected]
  );

  const onClick = useCallback(() => {
    setConsent({ types: selectedCookieTypes, createdAt: new Date().getTime() });
  }, [setConsent, selectedCookieTypes]);

  return (
    <button className={className} onClick={() => onClick()}>
      {text}
    </button>
  );
};

export default ConsentAcceptSelectedButton;
